import React, { useMemo, useState } from 'react';
import { Button, Col, Input, Pagination, Table } from 'antd';
import HeaderPage from '@sharedComponent/Header/Header';
import ImageComponent from '@sharedComponent/image-component';
import { images } from 'src/assets/img';
import './employeedetails.scss';
import { useHistory } from 'react-router-dom';

const Employeedetails = ({
	columns,
	handlerow,
	filteredData,
	selectvalue,
	head,
	handelPagiation,
	getemployeeData,
	loading,
	requestParams,
	isAdd,
	searchInput,
	setSearchInput,
	validate,
	clearvalidate,
	check,
	ordercardData,
}) => {
	const history = useHistory();
	return (
		<div>
			<HeaderPage />
			<Col className="table" xl={24} lg={24} md={24} sm={24} xs={24}>
				<Col className="mainbox" xl={22} lg={22} md={22} sm={22} xs={22}>
					<Col className="tabletab" xl={24} lg={24} md={24} sm={24} xs={24}>
						<Col className="title" xl={9} lg={9} md={24} sm={24} xs={24}>
							{head === 'select' ? (
								<p className="text">Select Employees To Order Cards</p>
							) : (
								<p className="text">Add And Select Employees To Order Cards</p>
							)}
						</Col>
						<Col className="field" xl={15} lg={15} md={24} sm={24} xs={24}>
							<Col xl={24} lg={24} md={24} sm={24} xs={24} className="fieldflex">
								<ImageComponent src={images.search} className="icon" />

								<input
									size="large"
									placeholder="Search by Name or Employee ID."
									className="searchbox"
									onChange={(e) => setSearchInput(e.target.value)}
								/>
							</Col>
						</Col>
					</Col>
					<Col xl={24} lg={24} md={24} sm={24} xs={24}>
						{ordercardData.length > 1 && <div className="ordercardData">{ordercardData}</div>}
						<Col xl={24} lg={24} md={24} sm={24} xs={24} className="table">
							<Table dataSource={filteredData} columns={columns} pagination={false} sticky loading={loading} />
						</Col>

						<Col xl={24} lg={24} md={24} sm={24} xs={24} className="addbox">
							<button className="addemployee" onClick={handlerow}>
								{' '}
								<ImageComponent src={images.plus} className="plus" />
								Add Employee
							</button>
						</Col>
						<Col xl={24} lg={24} md={24} sm={24} xs={24} className="addbox1">
							{!isAdd && (
								<Pagination
									current={requestParams?.pageNumber}
									total={getemployeeData?.totalEmployee}
									pageSize={10}
									simple={false}
									onChange={(e) => handelPagiation(e)}
									// {(getemployeeData?.totalEmployee,"length")}
									showSizeChanger={false}
								/>
							)}
						</Col>
					</Col>
					<Col xl={24} lg={24} md={24} sm={24} xs={24}>
						<Col className="footer" xl={22} lg={22} md={22} sm={22} xs={22}>
							<Col xl={10} lg={10} md={10} sm={10} xs={10}></Col>
							<Col xl={14} lg={14} md={14} sm={14} xs={14} className="buttontab">
								<Col xl={12} lg={12} md={12} sm={12} xs={12} className="skip-tab">
									<button
										className="skip"
										onClick={() => {
											history.push('/Conclusionpage');
										}}>
										Skip and Order Cards Later
									</button>
								</Col>
								<Col xl={10} lg={10} md={10} sm={10} xs={10}>
									<button className={clearvalidate ? 'order' : 'disablebutton'} onClick={() => selectvalue(null, 'orderCards')}>
										Order Cards
									</button>
								</Col>
							</Col>
						</Col>
					</Col>
				</Col>
			</Col>
		</div>
	);
};

export default Employeedetails;
